import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TELNYX_PHONE_NUMBERS_ACTION_TYPE } from '../actions';

const initialState = {
  ownedNumbers: [],
  searchResults: [],
  isLoading: false,
  isSearching: false,
  isOrdering: false,
  orderStatus: null,
};

const telnyxPhoneNumbersReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.GET_COMPANY_PHONE_NUMBERS:
        draft.ownedNumbers = Array.isArray(payload) ? payload : [];
        draft.isLoading = false;

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.SEARCH_AVAILABLE_NUMBERS:
        draft.searchResults = Array.isArray(payload) ? payload : [];

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.CLEAR_SEARCH_RESULTS:
        draft.searchResults = [];

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.ORDER_PHONE_NUMBERS:
        draft.orderStatus = payload;

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_ORDER_STATUS:
        draft.orderStatus = payload;

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.ASSIGN_PHONE_NUMBER:
        draft.ownedNumbers = draft.ownedNumbers.map(number =>
          number.phoneNumber === payload.phoneNumber
            ? { ...number, userId: payload.userId }
            : number,
        );

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.DELETE_PHONE_NUMBER:
        draft.ownedNumbers = draft.ownedNumbers.filter(number => number.phoneNumber !== payload);

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_SEARCHING:
        draft.isSearching = payload;

        return draft;

      case TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_ORDERING:
        draft.isOrdering = payload;

        return draft;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default telnyxPhoneNumbersReducer;
